<template>
  <div class="nav-scroller border-bottom">
    <div class="nav nav-tabs" ref="amendment-tabs">
      <a href="#" class="nav-link"
         v-bind:class="{ 'active': currentSection === 'GeneralInformation' }"
         @click="showSection('GeneralInformation')">
        Información general</a>
      <a href="#"
         class="nav-link"
         @click.prevent="showSection('ShowAmendment')">
        Consultar enmienda</a>
      <a :href="`/protocolo/${protocol.id}/consultar`"
         class="nav-link">
        Consultar protocolo</a>
      <a href="#" class="nav-link"
         data-target="#users-modal"
         data-toggle="modal"
         @click="showSection('AssignReviewers')">
        Asignar revisores a la enmienda</a>
      <a href="#" class="nav-link"
         v-bind:class="{ 'active': currentSection === 'DictumAmendment' }"
         @click="showSection('DictumAmendment')">
        Dictaminar enmienda</a>
    </div>
  </div>
</template>

<script>
  
  export default {
    name: 'CommitteeDictumAmendmentsTabs',
    props: {
      protocol: Object,
      amendment: Object,
    },
    data() {
      return {
        currentSection: 'GeneralInformation',
      }
    },
    methods: {
      showSection(section) {
        this.currentSection = section
        
        this.$emit('show-section', section)
      },
    },
  }
</script>
